import axios from "axios";
import config from "../config";

// Get API URL from environment or config
const getApiUrl = () => {
  // Check if we're in production and have environment variables
  if (process.env.NODE_ENV === 'production') {
    // In production, try to get from window object (set by server)
    if (typeof window !== 'undefined' && window.APP_CONFIG) {
      return window.APP_CONFIG.API_URL;
    }
  }
  
  // Fallback to config
  return config.API_URL;
};

export const BASE_URL = getApiUrl();

const axiosApi = axios.create({
  baseURL: BASE_URL,
});

export const api = axiosApi;

api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const loginAdmin = async (email, password) => {
  const response = await api.post(
    "/api/auth/admin/login",
    { email, password }, // Pass the email and password as the second argument
    { headers: { "Content-Type": "application/json" } } // Ensure headers are set correctly
  );
  return response.data;
};

export const logoutAdmin = async () => {
  const response = await api.post("/api/auth/admin/logout");
  return response.data;
};
export const uploadAdminImage = async (formdata) => {
  const response = await api.post("/api/images/upload", formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const vendors = async () => {
  const response = await api.get("/api/vendors");
  return response.data;
};

export const user = async () => {
  const response = await api.get("/api/users/");
  return response.data;
};
export const order = async () => {
  const response = await api.get("/api/orders/admin/");
  return response.data;
};
export const payout = async () => {
  const response = await api.get("/api/payouts/");
  return response.data;
};
export const dashboarddata = async () => {
  const response = await api.get("/api/analytics/dashboard-data");
  return response.data;
};
export const createUser = async (name, email, password, mobile) => {
  const response = await api.post("/api/auth/user/register", {
    name,
    email,
    password,
    mobile,
  });
  return response;
};

export const changepassword = async (password) => {
  const _id = sessionStorage.getItem("id");
  const response = await api.put("/api/auth/updateAdminPassword/" + _id, {
    password,
  });
  return response;
};
export const updateImage = async (imageUrl) => {
  const _id = sessionStorage.getItem("id");
  const response = await api.put("/api/auth/updateImage/" + _id, {
    imageUrl,
  });
  return response;
};
export const forgotPassword = async (email) => {
  const response = await api.post("/api/auth/forgot-password-admin", {
    email,
  });
  return response;
};
export const createVendor = async (
  name,
  email,
  phoneNumber,
  businessName,
  category,
  password
) => {
  const response = await api.post("/api/auth/vendor/register", {
    name,
    email,
    phoneNumber,
    businessName,
    category,
    password,
  });
  return response;
};
export const createCategory = async (name, imageUrl = "") => {
  const response = await api.post("/api/categories/create", {
    name,
    imageUrl,
  });
  return response;
};

export const createSubcategory = async (name, category, imageUrl = "") => {
  console.log(category);

  const response = await api.post("/api/subcategories/create", {
    name,
    category,
    imageUrl,
  });
  return response;
};
export const updateCategoryImage = async (imageUrl, id) => {
  console.log(category);

  const response = await api.put(`/api/categories/image/${id}`, {
    imageUrl,
    id,
  
  });
  return response;
};
export const updateSubCategoryImage = async (imageUrl, id) => {
  console.log(category);

  const response = await api.put(`/api/subcategories/image/${id}`, {
    imageUrl,
    id,
  
  });
  return response;
};
export const category = async () => {
  const response = await api.get("/api/categories/");
  return response.data;
};

export const updateUserStatus = async (userId, status) => {
  try {
    const response = await api.patch(`/api/users/${userId}/status`, {
      status,
    });
    console.log("Status updated successfully", response.data);
  } catch (error) {
    console.error("Error updating status", error);
  }
};

export const updateVendorStatus = async (vendorId, newStatus) => {
  try {
    const response = await api.put(`/api/vendors/${vendorId}/status`, {
      status: newStatus,
    });
    console.log("Vendor status updated:", response.data);
  } catch (error) {
    console.error("Error updating vendor status:", error);
  }
};
export const updatePayout = async (payoutId) => {
  try {
    const response = await api.put(`/api/payouts/${payoutId}/complete`);
    console.log("Vendor status updated:", response.data);
  } catch (error) {
    console.error("Error updating vendor status:", error);
  }
};
// Vendor Detail Stats
export const fetchVendorAnalytics = async (vendorId) => {
  try {
    const response = await api.get(
      `/api/analytics/vendor/${vendorId}/analytics`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching analytics:", error);
    throw error;
  }
};
export const sendNotification = async (title, body, view) => {
  console.log(category);

  const response = await api.post("/api/notifications/", {
    title,
    body,
    view,
  });
  return response;
};

// Function to fetch category vendor analytics
export const fetchCategoryVendorAnalytics = async (timeline) => {
  const response = await api.get(
    `/api/analytics/category/analytics?timeline=${timeline}`
  );
  return response.data;
};
export const fetchUserNotification = async (timeline) => {
  const response = await api.get(`/api/notifications/user-notifications`);
  return response.data;
};
export const fetchVendorNotification = async (timeline) => {
  const response = await api.get(`/api/notifications/vendor-notifications`);
  return response.data;
};
// Fetch subscribers by category - Dashboard
export const fetchSubscribersByCategory = async (timeline) => {
  const response = await api.get(
    `/api/subscriptions/category/analytics?timeline=${timeline}`
  );
  return response.data;
};
export const deleteCategory = async (id) => {
  const response = await api.delete(`/api/categories/${id}`);
  return response.data;
};
export const deleteSubCategory = async (id) => {
  const response = await api.delete(`/api/subcategories/${id}`);
  console.log(id);
  
  return response.data;
};
export default api;
